import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, Bond, PageOptions } from "cw-backend";
import { BehaviorSubject, Observable } from "rxjs";
import { FilterTO } from "../../../../models/operational/filter/filterTO";

@Injectable()
export class AccountsPayableListProvider implements Resolve<any> {
    bond: Bond[];
    bondEdit: Bond;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;
    path = "accounts-payable/";

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.bondEdit = this.state?.currentBond;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "document";
        }
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    get(id: number): Observable<Bond> {
        if (!id) {
            return null;
        }
        return this.gw.get("bond/:id", { id: id });
    }

    get currentBond(): Bond {
        return this.bondEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("bond/").subscribe({
                next: (res: HttpResponse<any>) => {
                    this.bond = res.body;
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: FilterTO): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`${this.path}search`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
